import { render } from "./ExpenseFeeModalSectionFiles.vue?vue&type=template&id=067ee157&scoped=true"
import script from "./ExpenseFeeModalSectionFiles.vue?vue&type=script&lang=js"
export * from "./ExpenseFeeModalSectionFiles.vue?vue&type=script&lang=js"

import "./ExpenseFeeModalSectionFiles.vue?vue&type=style&index=0&id=067ee157&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067ee157"]])

export default __exports__